"use client";

import React from "react";
import { Target, Eye, TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const values = [{
  title: "Uncompromising Quality",
  description: "We deliver high-intent, exclusive leads tailored specifically to your home improvement business needs, ensuring maximum conversion potential.",
  icon: Target
}, {
  title: "Absolute Transparency",
  description: "Clear reporting, honest communication, and full visibility into your campaign performance at every step of the lead generation process.",
  icon: Eye
}, {
  title: "Infinite Scalability",
  description: "Whether you need a steady trickle or a massive influx of leads, our systems and strategies grow seamlessly with your ambition.",
  icon: TrendingUp
}];
export default function CoreValues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="core-values" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-[128px] pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-primary/5 rounded-full blur-[128px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-6">
            The Pillars of Our Success
          </h2>
          <p className="text-lg text-muted-foreground">
            At Axebox Media, our approach to lead generation is built on a foundation of core principles that drive results and foster long-term partnerships.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value, i) => {
          const Icon = value.icon;
          return <div key={value.title} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 100} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="h-full bg-card/30 backdrop-blur-xl border-white/10 transition-all duration-300 hover:-translate-y-[10px] hover:shadow-2xl hover:shadow-primary/20 hover:bg-card/50 hover:border-primary/30 group">
                  <CardHeader className="pb-4">
                    <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6 text-primary transition-transform duration-300 group-hover:scale-110 group-hover:bg-primary/20">
                      <Icon className="w-7 h-7" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-2xl font-semibold tracking-tight">
                      {value.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground leading-relaxed">
                      {value.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}